/***
 * Created on 2024/9/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import ForceChinaPhone from "../component/user_warning/force_china_phone";

export default ForceChinaPhone